export enum BasketQuestion {
  Checkout = "BASKET_CHECKOUT",
  CardDetails = "BASKET_CARD_DETAILS",
}
